import { ItemCommandResult, QueryApiService } from 'src/common/api-service';
import { ShortLinkAccessStatus, ShortLinkResponse } from './short-list-types';

export class ShortLinkApiService extends QueryApiService<any> {
  constructor() {
    super('shortLinks');
  }

  public async getOriginalUrl(shortCode: string): Promise<ItemCommandResult<ShortLinkResponse>> {
    try {
      const res = await this.get<ItemCommandResult<ShortLinkResponse>>(`get-original-url/${encodeURIComponent(shortCode)}`);
      return res;
    } catch {
      return {
        item: { status: ShortLinkAccessStatus.NotFound, url: undefined },
        isSuccess: false,
        error: 'Error desconocido al obtener el enlace original.',
        identity: ''
      };
    }
  }
}
